<template>
  <div class="flex justify-between border-bottom">
    <el-breadcrumb class="el-one" v-if="!listType">
      <el-breadcrumb-item>{{last.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!--  -->
    <el-breadcrumb class="el-one" v-if="listType">
      <el-breadcrumb-item>当前剩余查看次数：<span class="red">{{listType}}</span>次</el-breadcrumb-item>
    </el-breadcrumb>
    <!--  -->
    <el-breadcrumb class="el-two" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item,index) in list"
        :key="index"
        :to="{ path: item.url }"
      >{{item.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    },
    listType: {
      type: String
    }
  },
  watch: {
    listType(n){
      this.listType = n
    }
  },
  data() {
    return {
      dataList: this.list,
      last: ''
    };
  },
  mounted(){
    this.last = this.dataList[this.dataList.length-1]
  }
};
</script>

<style>
.el-breadcrumb {
  min-height: 70px;
  line-height: 70px;
  /* border-bottom: 1px solid #cccccc; */
}
.el-breadcrumb__item .el-breadcrumb__inner {
  display: inline-block;
  height: 100%;
  font-weight: normal
}
.el-one .el-breadcrumb__item:first-of-type .el-breadcrumb__inner {
  border-bottom: 2px solid #ff6633;
}
.el-two .el-breadcrumb__inner:last-of-type{
  color: #FF6633 !important
}
.el-two{
  font-size: 12px !important
}
.red{
  color: red;
}
</style>